import _objectSpread from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["eventHandlers", "params", "url"];
import { createElementObject, createTileLayerComponent, updateGridLayer, withPane } from '@react-leaflet/core';
import { TileLayer } from 'leaflet';
export var WMSTileLayer = createTileLayerComponent(function createWMSTileLayer(_ref, context) {
  var _eh = _ref.eventHandlers,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    url = _ref.url,
    options = _objectWithoutProperties(_ref, _excluded);
  var layer = new TileLayer.WMS(url, _objectSpread(_objectSpread({}, params), withPane(options, context)));
  return createElementObject(layer, context);
}, function updateWMSTileLayer(layer, props, prevProps) {
  updateGridLayer(layer, props, prevProps);
  if (props.params != null && props.params !== prevProps.params) {
    layer.setParams(props.params);
  }
});